import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Footerbar from './components/Footerbar';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';


function VerifyInvitationInfoUpdate() {

    const { isSidebarVisible, showSidebar, toggleSidebar } = useAppLayout();

    const loggedInUserId = localStorage.getItem("user_id");
    const loggedFamilyAdmin = localStorage.getItem("family_admin");
    const navigate = useNavigate();
  const queryClient = useQueryClient();


  const {
    data: detailedFamily,
    isLoading: isDetailedLoading,
    isError: isDetailedError,
  } = useQuery({
    queryKey: ['familyDetails'],
    queryFn: async () => {
      const res = await axios.get(
        `${API_URL}/register-family-details-api`,
        { withCredentials: true }
      );
      return res.data;
    },
    staleTime: 0,
    cacheTime: Infinity,
  });


  
const [isSubmitting, setIsSubmitting] = useState(false);

const handleSubmit = (e) => {
  e.preventDefault();

   
};
  
return (
  <div className="scrollPageContainer theme-light">
    <div className="main-wrapper">
      {/* start of header */}
      {isSidebarVisible && <Sidebar />}
      <Header toggleSidebar={toggleSidebar} />
      {/* end of header */}

      {/* start of sidebar */}
      <Sidebar show={showSidebar} toggle={toggleSidebar} />
      {/* End of sidebar */}

      {/* start of footerbar */}
      <Footerbar toggleSidebar={toggleSidebar} />
      {/* end of footerbar */}

      <ToastContainer />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-8 col-xl-7">

              {/* ✅ remove overflow-hidden (it can clip dropdowns) */}
                            <div
                style={{
                  background: '#ffffff',
                  borderRadius: '24px',
                  overflow: 'hidden',
                 
                  animation: 'fadeInUp 0.5s ease-out',
                }}
              >
                {/* Header */}
                <div
                  style={{
                    background: 'linear-gradient(135deg, #184A2C 0%, #0a5520 100%)',
                    padding: '1.75rem 1.5rem 1.5rem',
                  }}
                >
                  <div className="d-flex align-items-start justify-content-between flex-wrap gap-2">
                    <div>
                      <h5 style={{ color: '#fff', fontWeight: 700, marginBottom: '0.25rem' }}>
                        Family Info
                      </h5>
                      <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: '0.8rem', margin: 0 }}>
                        Check the lineage details are correct
                      </p>
                    </div>
 
                    <div
                      className="px-3 py-2"
                      style={{
                        background: 'rgba(255,255,255,0.15)',
                        borderRadius: '999px',
                        color: '#fff',
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        border: '1px solid rgba(255,255,255,0.25)',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      Step 1 of 2
                    </div>
                  </div>
 
                   
                </div>
 
                {/* Body */}
                <div className="p-3 p-md-4" style={{ paddingBottom: 28 }}>
                  <div className="row">
                    {isDetailedLoading && (
                      <div className="text-center py-5">
                        <span
                          className="spinner-border"
                          role="status"
                          style={{ width: '2rem', height: '2rem', color: '#184A2C' }}
                        ></span>
                        <p className="mt-3" style={{ color: '#8aa899', fontSize: '0.85rem' }}>
                          Loading lineage details...
                        </p>
                      </div>
                    )}
 
                    {isDetailedError && (
                      <div
                        style={{
                          background: '#fdecea',
                          borderLeft: '3px solid #c0392b',
                          borderRadius: '8px',
                          padding: '0.875rem',
                          margin: '0.75rem 0',
                        }}
                      >
                        <p style={{ color: '#7a2118', fontSize: '0.85rem', margin: 0, fontWeight: 500 }}>
                          Error loading family details. Please try again.
                        </p>
                      </div>
                    )}
 
                    {detailedFamily && (
                      <>
                        {/* Family name banner */}
                        <div
                          style={{
                            background: 'linear-gradient(135deg, #184A2C 0%, #0a5520 100%)',
                            borderRadius: '16px',
                            padding: '1.1rem 1.25rem',
                            marginBottom: '1.25rem',
                          }}
                        >
                          <h6
                            className="mb-2 text-uppercase"
                            style={{
                              color: 'rgba(255,255,255,0.75)',
                              fontSize: '0.7rem',
                              fontWeight: 700,
                              letterSpacing: '0.04em',
                            }}
                          >
                            Family
                          </h6>
                          <h4 style={{ color: '#fff', margin: 0, fontWeight: 700 }}>
                            {detailedFamily.family_name}
                          </h4>
                        </div>
 
                        {/* Lineage strip */}
                        <div
                          className="d-flex flex-wrap align-items-center gap-3 py-2 px-3"
                          style={{
                            background: '#f8fcf9',
                            border: '1px solid #e5ede8',
                            borderRadius: '12px',
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <small
                              className="fw-bold text-uppercase me-2"
                              style={{ fontSize: '0.65rem', color: '#8aa899' }}
                            >
                              Tribe:
                            </small>
                            <span className="small fw-semibold" style={{ color: '#184A2C' }}>
                              {detailedFamily.tribe_name}
                            </span>
                          </div>
 
                          {[
                            { label: 'Sub-Tribe', value: detailedFamily.sub_tribe_name },
                            { label: 'Sub-Group', value: detailedFamily.sub_group_name },
                            { label: 'Clan', value: detailedFamily.clan_name },
                          ].map(
                            (item, idx) =>
                              item.value && (
                                <div
                                  key={idx}
                                  className="d-flex align-items-center ps-3"
                                  style={{ borderLeft: '1px solid #e5ede8' }}
                                >
                                  <small
                                    className="fw-bold text-uppercase me-2"
                                    style={{ fontSize: '0.65rem', color: '#8aa899' }}
                                  >
                                    {item.label}:
                                  </small>
                                  <span className="small fw-semibold" style={{ color: '#184A2C' }}>
                                    {item.value}
                                  </span>
                                </div>
                              )
                          )}
 
                          {detailedFamily.totem_name && (
                            <div className="ms-auto">
                              <span
                                className="rounded-pill fw-medium"
                                style={{
                                  fontSize: '0.7rem',
                                  padding: '0.3rem 0.7rem',
                                  background: 'rgba(13,110,40,0.1)',
                                  color: '#184A2C',
                                  border: '1px solid rgba(13,110,40,0.2)',
                                }}
                              >
                                <i className="fas fa-shield-alt me-1"></i>
                                {detailedFamily.totem_name}
                              </span>
                            </div>
                          )}
                        </div>
 
                        <hr style={{ margin: '1.5rem 0', borderColor: '#e5ede8', opacity: 1 }} />
 
                        {/* People you may know */}
                        <div>
                          <h6
                            className="fw-bold mb-3 d-flex align-items-center"
                            style={{ color: '#184A2C', fontSize: '0.9rem' }}
                          >
                            <span className="me-2" style={{ color: '#ff6600' }}>
                              ●
                            </span>
                            People you may know
                          </h6>
                          <div className="d-flex flex-wrap gap-2">
                            {(detailedFamily?.admin || []).map((admin, idx) => (
                              <div
                                key={idx}
                                className="d-inline-flex align-items-center rounded-pill px-3 py-2"
                                style={{
                                  background: '#f8fcf9',
                                  border: '1px solid #e5ede8',
                                  boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                                }}
                              >
                                <div
                                  className="rounded-circle d-flex align-items-center justify-content-center me-2"
                                  style={{
                                    width: '24px',
                                    height: '24px',
                                    fontSize: '12px',
                                    background: '#184A2C',
                                    color: '#fff',
                                  }}
                                >
                                  {admin.name?.charAt(0)}
                                </div>
 
                                <span className="small fw-medium" style={{ color: '#184A2C' }}>
                                  {admin.n_prefix && (
                                    <span style={{ color: '#8aa899' }} className="me-1">
                                      {admin.n_prefix}
                                    </span>
                                  )}
                                  {admin.name} {admin.last_name}
                                </span>
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
 
                  {/* Actions */}
                  <div className="d-flex justify-content-between align-items-center gap-2 mt-4">
                    <Link
                      to="/verify-invitation-reject"
                      style={{
                        padding: '0.7rem 1.4rem',
                        backgroundColor: 'transparent',
                        color: '#184A2C',
                        border: '1.5px solid #184A2C',
                        borderRadius: '40px',
                        fontSize: '0.85rem',
                        fontWeight: 600,
                        textDecoration: 'none',
                        transition: 'all 0.2s ease',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#184A2C';
                        e.currentTarget.style.color = '#fff';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                        e.currentTarget.style.color = '#184A2C';
                      }}
                    >
                      Reject Invitation
                    </Link>
 
                    <Link
                      to="/verify-invitation-info-confirm"
                      className="btn btn-primary d-inline-flex align-items-center justify-content-center"
                      style={{
                        minWidth: 120,
                        padding: '0.7rem 1.4rem',
                        
                        border: 'none',
                        borderRadius: '40px',
                        fontWeight: 600,
                        fontSize: '0.85rem',
                        color: '#fff',
                        textDecoration: 'none',
                        transition: 'all 0.2s ease',
                      }}
                      
                    >
                      Next »
                    </Link>
                  </div>
                </div>
              </div>






              <div style={{ height: 8 }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

}

export default VerifyInvitationInfoUpdate;
